import { createActions } from 'redux-actions';

export const getType = (reduxAction) => {
  return reduxAction.type;
};

export const getSuppliers = createActions({
  getSuppliersRequest: (payload) => payload,
  getSuppliersSuccess: (payload) => payload,
  getSuppliersFailure: (error) => error,
});

export const createSupplier = createActions({
  createSupplierRequest: (payload) => payload,
  createSupplierSuccess: (payload) => payload,
  createSupplierFailure: (error) => error,
});

export const updateSupplier = createActions({
  updateSupplierRequest: (payload) => payload,
  updateSupplierSuccess: (payload) => payload,
  updateSupplierFailure: (error) => error,
});

export const deleteSupplier = createActions({
  deleteSupplierRequest: (payload) => payload,
  deleteSupplierSuccess: (payload) => payload,
  deleteSupplierFailure: (error) => error,
});
